import { render, staticRenderFns } from "./Groups.vue?vue&type=template&id=a6708028"
import script from "./groups.js?vue&type=script&lang=js&external"
export * from "./groups.js?vue&type=script&lang=js&external"
import style0 from "./groups.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports